import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox, ControlLabel} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hour: '',
            affid: null,
            country: null,
            subid: null,
            tracker: null,
            partner: null,
            day: '',
            quality: '',
            affidLimit: '',
            pushapi: '',
            groupBy: {},
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.partner) return;

        if (!this.props.partnerValues ||
            !this.props.partnerValues[this.state.tracker] ||
            this.state.partner.some((partner) => !this.props.partnerValues[this.state.tracker].includes(partner))
        ) {
            this.setState({ ...this.state, partner: null });
        }
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if(checked) groupBy[name] = 1;
        else delete groupBy[name];

        this.setState({ groupBy });
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm();
        const filters = Object.assign({}, this.state);
        filters.groupBy = Object.keys(filters.groupBy);

        if(filters.compareDay) filters.compare = 1;

        if(isValid) this.props.onSubmit(filters, type);
    }

    validateForm() {
        const { day } = this.state;

        let alert = null;

        if(!day) alert = 'Please set Day';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if (alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}

                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>
                        <Checkbox onChange={this.handleGroupByChange} name="date">Date</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="hour">Hour</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="affid">Affid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="subid">Subid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>
                    </Col>
                </Row>
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourFrom"
                            label="Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourTo"
                            label="Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourTo}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="compareDay"
                            label="Compare Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDay}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="compareHourFrom"
                            label="Cmp. Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.compareHourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="compareHourTo"
                            label="Cmp. Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.compareHourTo}
                        />
                    </Col>

                </Row>
                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={{ ak: 'AdKernel', pc: 'PeerClick', pa: "PushAPI", vl: 'Voluum', zp: 'ZeroPark', adk: 'ADK', pl: 'Plugin Report' }}
                            label="Tracker:"
                            name="tracker"
                            onChange={this.handleFieldChange}
                            value={this.state.tracker}
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.tracker ? this.props.partnerValues[this.state.tracker] : []}
                            label="Partner:"
                            name="partner"
                            onChange={this.handleFieldChange}
                            value={this.state.partner}
                            disabled={!this.state.tracker || !this.props.partnerValues[this.state.tracker]}
                            placeholder={(!this.state.tracker && "Select tracker first") || (!this.props.partnerValues[this.state.tracker] && "This tracker not supported")}
                            multi
                            required
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={2}>
                        <Checkbox onChange={this.handleCheckboxChange} name="affidLimit">
                            Affid Limit
                        </Checkbox>
                    </Col>
                    <Col lg={2}>
                        <Checkbox onChange={this.handleCheckboxChange} name="pushapi">
                            Pushapi Affid
                        </Checkbox>
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('custom')}>Load</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('affid')}>Load Affid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('subid')}>Load Subid</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderNetworkPerformanceHourlyV2/components/Form/index.js